import { render } from "./LegislationShow.vue?vue&type=template&id=7ceb2b67"
import script from "./LegislationShow.vue?vue&type=script&lang=js"
export * from "./LegislationShow.vue?vue&type=script&lang=js"

import "./LegislationShow.vue?vue&type=style&index=0&id=7ceb2b67&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__